import { render, staticRenderFns } from "./Expertize.vue?vue&type=template&id=1f166ec5&scoped=true&"
import script from "./Expertize.vue?vue&type=script&lang=js&"
export * from "./Expertize.vue?vue&type=script&lang=js&"
import style0 from "./Expertize.vue?vue&type=style&index=0&id=1f166ec5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f166ec5",
  null
  
)

export default component.exports